import React from "react";
import { Header } from "../../../../styleguide/atoms/index.js";
import { PopupWrapper, PopupRow, PopupResults } from "../../styles/Game.styles";
import { CharacterCard } from "../CharacterCard.js";
import { joinWithAnd } from "../../utils/gameUi";

export default function DayOverlay({
  dayKillVictims = [],
  roleAssets,
  renderRichText,
  daySaved,
  daySavedAsset,
  daySavedDescNodes,
  daySavedReason,
}) {
  const hasKills = dayKillVictims.length > 0;
  const hasSaved = !!daySaved;

  if (!hasKills && !hasSaved) {
    return (
      <PopupWrapper>
        <PopupResults>
          <Header type="h3" align="center" padding="0">
            No one was eliminated!
          </Header>
        </PopupResults>
      </PopupWrapper>
    );
  }

  const eliminatedNames = (dayKillVictims || [])
    .map((v) => v?.name)
    .filter(Boolean);
  const elimVerb = eliminatedNames.length === 1 ? "was" : "were";

  return (
    <PopupWrapper>
      {hasSaved && (
        <PopupResults>
          <Header
            type="h3"
            align="center"
            padding={daySavedReason === "nurse" ? "0" : undefined}
          >
            {daySavedReason === "nurse"
              ? `The Nurse protected ${daySaved.name} from elimination!`
              : `${daySaved.name} has survived the vote.`}
          </Header>
          {daySavedReason !== "nurse" && (
            <CharacterCard
              image={daySavedAsset?.imageUrl || ""}
              description={daySavedDescNodes}
              role={daySaved?.team || ""}
              status={"Alive"}
              title={daySaved?.roleTitle || ""}
              listView={false}
              player={daySaved?.name || ""}
            />
          )}
        </PopupResults>
      )}

      {hasKills && (
        <PopupResults>
          <Header type="h3" align="center">
            {eliminatedNames.length > 0
              ? `${joinWithAnd(eliminatedNames)} ${elimVerb} eliminated:`
              : "Eliminated:"}
          </Header>
          <PopupRow>
            {dayKillVictims.map((v) => {
              const asset = v?.roleId ? roleAssets[v.roleId] : null;
              const desc = asset?.descriptionRich
                ? renderRichText(asset.descriptionRich)
                : null;
              return (
                <CharacterCard
                  key={v.id}
                  image={asset?.imageUrl || ""}
                  description={desc}
                  role={v?.team || ""}
                  status={"Dead"}
                  title={v?.roleTitle || ""}
                  listView={false}
                  player={v?.name || ""}
                />
              );
            })}
          </PopupRow>
        </PopupResults>
      )}
    </PopupWrapper>
  );
}
